/* eslint-disable @typescript-eslint/naming-convention */
import React, { useEffect, useState, useRef } from 'react';
import { readQueryParameter } from '../../../utils/pageInfo';
import Context from './Context';
import { getCurrentStore } from '../../selectors/metaData';
import { getStoreInformation } from '../../../utils/sisUtils';

interface FeatureProps {
  featureName: string;
  // children: React.ReactChildren;
}

const Feature: React.FC<FeatureProps> = (props: FeatureProps) => {
  const { featureName, children } = props;

  const { google_optimize, location, __PRELOADED_STATE__: state = {} } = window;
  const { flags : { optimizeExperiments = {}, childStores=[] } = {} } = state ;
  const currentStore = getCurrentStore(state);
  const storeValue = getStoreInformation ([], currentStore);
  const liveExperiments = optimizeExperiments?.[storeValue];

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const featureId: string = window[featureName];
  let defaultVariant = '0';
  const { isPreview } = readQueryParameter(location);
  /**
   * set defaultVarient to 1 if it is a preview page
   */
  if (isPreview) {
    defaultVariant = '1';
  }

  const [variant, setVariant] = useState(defaultVariant);

  let googleOptimizeFeatureValue: string;
  if (!isPreview) {
    // googleOptimizeFeatureValue = google_optimize.get(featureId) || '0';
    googleOptimizeFeatureValue = liveExperiments?.[featureName] || '0';
  }
  const updateVariant = (value: string): void => {
    // if feature not active, render original
    const newVariant: string = value === undefined || value === null ? '0' : value;
    if (newVariant !== variant) {
      setVariant(newVariant);
    }
  };
  const handleVariantUpdate = useRef(() => {});
  handleVariantUpdate.current = (): void => {
    // Google Optimize already loaded
    if (!isPreview) {
      updateVariant(googleOptimizeFeatureValue);
    }
  };

  useEffect(() => {
    handleVariantUpdate.current();
  }, []);

  return <Context.Provider value={variant}>{children}</Context.Provider>;
};

export const getFeatureVariant: (a: string) => string = (featureName = '') => {
  const { isPreview } = readQueryParameter(window.location);
  if (isPreview) {
    return '1';
  }
  const { google_optimize,  __PRELOADED_STATE__: state = {} } = window;
  const { flags : { optimizeExperiments = {}, childStores=[] } = {} } = state ;
  const currentStore = getCurrentStore(state);
  const storeValue = getStoreInformation ([], currentStore);
  const liveExperiments = optimizeExperiments?.[storeValue?.toLowerCase()];
  const googleOptimizeFeatureValue = liveExperiments?.[featureName] || '0';

/** 
  //G. optimize support is deprecated.

  const featureId = window[featureName];
  let googleOptimizeFeatureValue = '0';
  if (google_optimize) {
    googleOptimizeFeatureValue = google_optimize.get(featureId) || '0';
  }
*/
  return googleOptimizeFeatureValue;
};

export const getVariant = (featureName = '', multiVariant = false) => {
  const { isPreview } = readQueryParameter(window.location);
  if (isPreview) {
    return true;
  }
  if (multiVariant) {
    return getFeatureVariant(featureName) !== '0'
      ? parseInt(getFeatureVariant(featureName))
      : false;
  }
  // console.log(`Feature name ${featureName}; Value ${getFeatureVariant(featureName)}`)
  return getFeatureVariant(featureName) !== '0';
};

export default Feature;
